import { EASE } from "@nnf3d/lib";
import { m } from "motion/react";

import { useGlobal } from "../lib/global-context";
import type { VoidComponent } from "../lib/types";
import { Icon } from "./icon";

const swipeAnimate = { y: ["-50%", "50%", "-50%"] };
const swipeTransition = {
	duration: 2.4,
	ease: EASE.IN_OUT_QUART,
	repeat: Number.POSITIVE_INFINITY,
};

const swipeWillChangeStyle = { willChange: "transform" } as const;

interface Props {
	text?: string;
}

const ScrollIndicator: VoidComponent<Props> = ({ text }) => {
	const { scrollIndicatorText } = useGlobal();
	const displayText = text ?? scrollIndicatorText;

	return (
		<div className="absolute bottom-full left-0 z-100 mb-4 flex items-center gap-2">
			<div className="flex h-9 w-6 items-center justify-center rounded-full border border-stroke-muted">
				<m.div
					animate={swipeAnimate}
					transition={swipeTransition}
					className="size-2"
					style={swipeWillChangeStyle}
				>
					<Icon name="down" className="size-2 text-accent" />
				</m.div>
			</div>

			<p className="max-w-24 text-xs leading-4">{displayText}</p>
		</div>
	);
};

export { ScrollIndicator };
